import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.fill.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("click", this.fill.bind(this));
  }

  fill() {
    const target = document.querySelector(this.element.dataset.inputFillTarget)
    if (target) {
      target.value = this.element.dataset.inputFillValue
      target.dispatchEvent(new Event("input", { bubbles: true }))
      target.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
